<template>
  <article class="xp">
    <time class="xp__when">{{ dateLabel }}</time>
    <div class="xp__marker" aria-hidden="true" />
    <div class="xp__body">
      <p class="xp__lead">
        <span class="xp__role">{{ title }}</span>
        <span class="xp__at"> at </span>
        <span class="xp__company">
          <template v-if="companyLinks && companyLinks.length">
            <template v-for="(link, i) in companyLinks" :key="link.url">
              <span v-if="i > 0" class="xp__company-sep"> &amp; </span>
              <a
                class="xp__company-link"
                :href="link.url"
                target="_blank"
                rel="noopener"
              >{{ link.name }}</a>
            </template>
          </template>
          <a
            v-else-if="companyUrl"
            class="xp__company-link"
            :href="companyUrl"
            target="_blank"
            rel="noopener"
          >{{ company }}</a>
          <template v-else>{{ company }}</template>
        </span><span class="xp__period">.</span>
      </p>
      <p
        v-for="(item, i) in assignments"
        :key="i"
        class="xp__detail"
      >
        {{ item }}
      </p>
    </div>
  </article>
</template>

<script>
export default {
  name: 'Experience',
  props: {
    title: String,
    company: String,
    companyUrl: String,
    companyLinks: Array,
    from: String,
    to: String,
    assignments: Array,
    tech_stack: Array
  },
  computed: {
    dateLabel () {
      if (!this.from) return ''

      const fromYear = this.from.split('/').pop()
      if (!this.to) return `${fromYear} -`

      const toYear = this.to.split('/').pop()
      if (fromYear === toYear) return fromYear

      return `${fromYear} - ${toYear}`
    }
  }
}
</script>

<style scoped>
.xp {
  display: grid;
  grid-template-columns: 5.75rem 1.5rem minmax(0, 1fr);
  gap: 0 1.35rem;
  align-items: start;
}

.xp__when {
  margin: 0;
  padding-top: 0.15rem;
  font-size: 0.92rem;
  line-height: 1.35;
  text-align: right;
  color: var(--ink-muted);
  font-style: normal;
  white-space: nowrap;
}

.xp__marker {
  position: relative;
  align-self: stretch;
  min-height: 1.25rem;
}

.xp__marker::before {
  content: '';
  position: absolute;
  top: 0.5rem;
  left: 50%;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--surface);
  border: 1.5px solid var(--ink-muted);
  transform: translateX(-50%);
  z-index: 1;
}

.xp__body {
  min-width: 0;
  padding-bottom: 0.15rem;
}

.xp__lead {
  margin: 0;
  line-height: 1.55;
  color: var(--ink-muted);
}

.xp__role {
  color: var(--ink);
  font-weight: 600;
}

.xp__at,
.xp__period {
  color: var(--ink-muted);
}

.xp__company {
  color: var(--accent);
  font-weight: 500;
}

.xp__company-sep {
  color: var(--accent);
}

.xp__company-link {
  color: inherit;
  text-decoration: none;
  border-bottom: 1px solid currentColor;
  transition: color 0.2s var(--ease), border-color 0.2s var(--ease);
}

.xp__company-link:hover {
  color: var(--ink);
  border-bottom-color: var(--ink);
}

.xp__company-link:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 3px;
}

.xp__detail {
  margin: 0.65rem 0 0;
  line-height: 1.55;
  color: var(--ink-muted);
}

@media (max-width: 640px) {
  .xp {
    grid-template-columns: 4.75rem 1.25rem minmax(0, 1fr);
    gap: 0 0.9rem;
  }

  .xp__when {
    font-size: 0.84rem;
  }
}
</style>
